import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://zubnaputjupjixduyrwc.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inp1Ym5hcHV0anVwaml4ZHV5cndjIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU4NzYyNzIsImV4cCI6MjA4MTQ1MjI3Mn0.4tb17ROxPlyl-FBUn30nr_HLrKtaX_DOK87UR8w1psE'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

export type Database = {
  public: {
    Tables: {
      profiles: {
        Row: {
          id: string
          email: string
          full_name: string | null
          avatar_url: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id: string
          email: string
          full_name?: string | null
          avatar_url?: string | null
        }
        Update: {
          email?: string
          full_name?: string | null
          avatar_url?: string | null
        }
      }
      projects: {
        Row: {
          id: string
          user_id: string
          name: string
          description: string | null
          thumbnail_url: string | null
          html_content: string | null
          css_content: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          user_id: string
          name: string
          description?: string | null
          thumbnail_url?: string | null
          html_content?: string | null
          css_content?: string | null
        }
        Update: {
          name?: string
          description?: string | null
          thumbnail_url?: string | null
          html_content?: string | null
          css_content?: string | null
        }
      }
      generations: {
        Row: {
          id: string
          project_id: string
          user_id: string
          prompt: string
          html_output: string | null
          css_output: string | null
          status: 'pending' | 'processing' | 'completed' | 'failed'
          error_message: string | null
          created_at: string
        }
        Insert: {
          project_id: string
          user_id: string
          prompt: string
          status?: 'pending' | 'processing' | 'completed' | 'failed'
        }
        Update: {
          html_output?: string | null
          css_output?: string | null
          status?: 'pending' | 'processing' | 'completed' | 'failed'
          error_message?: string | null
        }
      }
    }
  }
}

